import FieldValidator from '@/components/common/form/FieldValidator';
import { FormContext } from '@/components/common/form/FormContext';
import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';
import { VALIDATORS } from '@/constants/validators';

const DEFAULT_ROWS = 4;

class TextValidator extends FieldValidator {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isPwdVisible: false
    };
  }

  changePasswordVisibility() {
    this.setState((state) => ({
      isPwdVisible: !state.isPwdVisible
    }));
  }

  renderValidatorComponent() {
    const { isPwdVisible, isValid } = this.state;
    // Get DOM only props by excluding known component own props
    const {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
      errorMessages, type = 'text', validators, requiredError, validatorListener, withRequiredValidator,
      className, autofocus, multiline, rows = DEFAULT_ROWS, placeholder, value, id, rbf, ...rest
    } = this.props;

    validators.forEach((v) => {
      if (v === VALIDATORS.IS_REQUIRED) {
        rest.required = true;
      } else if (v.indexOf(VALIDATORS.MIN_LENGTH) >= 0) {
        rest.minLength = v.split(':')[1];
      }
    });

    return (
      <FormContext.Consumer>
        {(context) => {
          const validationClass = context.wasValidated ? (isValid ? ' is-valid' : ' is-invalid') : '';

          const renderInput = () => multiline ? (
            <textarea
              {...rest}
              id={id}
              data-rbf={rbf || `textarea${id ? '-' + id : ''}`}
              rows={rows || DEFAULT_ROWS}
              className={`form-control${className ? ' ' + className : ''}${validationClass}`}
              autoFocus={autofocus}
              placeholder={placeholder}
              value={value}
            />
          ) : (
            <input
              data-test-id="input-text"
              {...rest}
              id={id}
              data-rbf={rbf || `input${id ? '-' + id : ''}`}
              type={type === 'password' && isPwdVisible ? 'text' : type}
              className={`form-control${className ? ' ' + className : ''}${validationClass}`}
              autoFocus={autofocus}
              placeholder={placeholder}
              value={value}
            />
          );

          return (
            <div className={`form-group${validationClass}`}>
              {this.customLabel && (
                <label htmlFor={id}>{this.customLabel}</label>
              )}
              {type === 'password' ? (
                <div className="input-group">
                  {renderInput()}
                  <div className="visibility-button input-group-append" onClick={() => this.changePasswordVisibility()}>
                    <span className="input-group-text">
                      <Icon
                        src={isPwdVisible ? URLS.ICON_HIDDEN : URLS.ICON_VIEW}
                        alt={isPwdVisible ? 'hidden' : 'view'}
                        height={20}
                        width={20}
                      />
                    </span>
                  </div>
                </div>
              ) : (
                renderInput()
              )}
              {this.errorText()}
            </div>
          );
        }}
      </FormContext.Consumer>
    );
  }
}

export default TextValidator;
